var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v1cb",class:[
    {'v1cb-empty': _vm.isEmpty },
    {'v1cb-button': _vm.isButton },
    {'v1cb-accent': _vm.accented } ],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"v1cb-desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")]),_c('div',{staticClass:"v1cb-value"},[_vm._v(" "+_vm._s(_vm.isEmpty ? _vm.emptyValue || _vm.value : _vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }